import { useTranslation } from 'react-i18next';

/**
 * Marcador visual per als modes d'anàlisi que encara estan en construcció.
 * Quan cada mode tingui el seu endpoint, el panell corresponent substituirà
 * aquest component pel seu render real.
 */
export interface AnalyzerPlaceholderProps {
    title: string;                  // clau i18n del mode
    description?: string;           // clau i18n opcional amb una descripció del mode
}

export default function AnalyzerPlaceholder(props: AnalyzerPlaceholderProps) {
    const { t } = useTranslation();

    return (
        <div className="analyzer-placeholder">
            <h3>{ t(props.title) }</h3>
            { props.description &&
                <p className="analyzer-placeholder-desc">{ t(props.description) }</p>
            }
            <div className="analyzer-placeholder-badge">
                { t("This analysis type is still under construction.") }
            </div>
        </div>
    );
}
